export default __webpack_public_path__ + "static/media/icon-download.dea14775.svg";